import React, { useContext } from "react"
import tw from "twin.macro"
import { LocationContext } from "../../../contexts/Location"
import { setRadius } from "../../../contexts/Location/actions"
import { RadiusSelectorProps } from "./RadiusSelector.d"
import { DistanceSlider } from "../../../components/atoms/DistanceSlider"
import { FiltersContext } from "../../../contexts/Filters/context"
import { setSelectedFilterOption } from "../../../contexts/Filters/actions"
import { useTealiumContext } from "../../../contexts/Tealium"

const RadiusSelector: React.FC<RadiusSelectorProps> = ({
  fromInventory,
}): JSX.Element => {
  const [{ radius }, dispatch] = useContext(LocationContext)
  const [filtersState, dispatchFilters] = useContext(FiltersContext)
  const { tealPageData, swapInventoryFilterInQueue } = useTealiumContext()
  const steps: number[] = [25, 50, 100, 250, 500, 600]
  const position = steps.indexOf(radius) + 1

  const findNextHigherValue = (value: number): number => {
    const nextValue = steps.find(step => step >= value)
    return nextValue !== undefined ? nextValue : steps[steps.length - 1]
  }

  const handleRadiusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const distance = findNextHigherValue(Number(e.target.value))

    // First update location context
    dispatch(setRadius(distance))

    // Only update filters if we're in inventory view
    if (fromInventory) {
      dispatchFilters(setSelectedFilterOption("radius", distance))
      swapInventoryFilterInQueue(
        {
          refinement_value: `${tealPageData?.page_type}|${tealPageData?.page_name}|Radius|${distance}`,
        },
        `${tealPageData?.page_type}|${tealPageData?.page_name}|Radius|`,
      )
    }
  }

  return (
    <div css={[tw`flex items-center text-center`]}>
      <DistanceSlider
        min={Number(0)}
        minValue={Number(0)}
        max={Number(5)}
        radius={radius ? radius : 0}
        inputs
        maxValue={Number(5)}
        tabIndex={0 ? 0 : -1}
        onChange={handleRadiusChange}
        fromInventory={fromInventory}
        position={position}
      />
    </div>
  )
}

export default RadiusSelector
